<script>
import { add, update } from '@/api/general/geAttachment'

export default {
  name: 'GeAttachmentEditDialog',
  props: {
    businessId: {
      type: Number,
      required: false,
      default: null
    },
    businessSubId1: {
      type: Number,
      required: false,
      default: null
    },
    businessSubId2: {
      type: Number,
      required: false,
      default: null
    },
    businessSubId3: {
      type: Number,
      required: false,
      default: null
    },
    businessSubId4: {
      type: Number,
      required: false,
      default: null
    },
    businessAttr1: {
      type: String,
      required: false,
      default: null
    },
    businessAttr2: {
      type: String,
      required: false,
      default: null
    },
    // 参考：$enums.ATTACHMENT_BUSINESS_TYPE.[].value
    businessType: {
      type: Number,
      required: true
    },
    /**
     * 手动模式：开启后，新增和修改不会操作数据库
     */
    manual: {
      type: Boolean,
      default: false
    },
    formConfig: {
      type: Object,
      default: () => {
        return {
          businessAttr1Show: false,
          businessAttr1Label: '业务属性1',
          businessAttr2Show: false,
          businessAttr2Label: '业务属性2'
        }
      }
    },
    /**
     * 新增时扩展数据
     */
    addExtra: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      show: false,

      formLoading: false,
      form: {
        businessId: null,
        businessSubId1: null,
        businessSubId2: null,
        businessSubId3: null,
        businessSubId4: null,
        businessAttr1: null,
        businessAttr2: null,
        businessType: null,
        fileName: null,
        fileUrl: null,
        fileSize: null,
        fileExt: null,
        fileDesc: null,
      },
      rules: {
        fileName: [
          { required: true, message: '文件名称不能为空', trigger: 'change' }
        ],
        fileUrl: [
          { required: true, message: '文件url不能为空', trigger: 'change' }
        ],
        fileSize: [
          { required: true, message: '文件大小不能为空', trigger: 'change' }
        ],
        fileExt: [
          { required: true, message: '扩展名不能为空', trigger: 'change' }
        ],
      },
    }
  },
  computed: {
    title() {
      return this.form.id ? '修改附件' : '上传附件'
    }
  },
  methods: {
    open(row) {
      Object.assign(this.$data, this.$options.data())
      this.form = Object.assign(this.form, row)
      this.form.businessId = this.businessId
      this.form.businessSubId1 = this.businessSubId1
      this.form.businessSubId2 = this.businessSubId2
      this.form.businessSubId3 = this.businessSubId3
      this.form.businessSubId4 = this.businessSubId4
      this.form.businessAttr1 = this.businessAttr1
      this.form.businessAttr2 = this.businessAttr2
      this.form.businessType = this.businessType
      this.show = true
    },
    onSubmit() {
      this.$refs['form'].validate(valid => {
        if (!valid) {
          return false
        }

        if (!this.form.id) {
          Object.assign(this.form, this.addExtra)
        }

        // 检查是否新增模式
        if (this.manual) {
          this.$message.success('操作成功')
          this.show = false
          const res = {...this.form}
          const isAdd = !this.form._id
          if (isAdd) {
            res._id = this.dayjs().valueOf()
            res._add = true
          } else {
            res._add = false
          }
          this.$emit('complete', res)
          return
        }

        this.formLoading = true
        const reqPromise = this.form.id ? update(this.form) : add(this.form)
        reqPromise.then(() => {
          this.$message.success('操作成功')
          this.show = false
          this.$emit('complete')
        }).finally(() => {
          this.formLoading = false
        })
      })
    },
    onDialogOpen() {
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate();
        }
      });
    },
    onSuccessCallback(response) {
      this.form.fileName = response?.name
      this.form.fileExt = response?.ext
      this.form.fileSize = response?.size
    },
    onFileRemove() {
      this.form.fileName = null
      this.form.fileExt = null
      this.form.fileSize = null
    }
  }
}
</script>

<template>
  <el-dialog
    :title="title"
    :visible.sync="show"
    :close-on-click-modal="false"
    width="700px"
    @open="onDialogOpen"
    append-to-body
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="120px">
      <el-form-item label="文件" prop="fileUrl">
        <upload-file
          v-if="show"
          v-model="form.fileUrl"
          upload-api="/api/upload/uploadFile"
          :single-mode="true"
          :limit="10"
          tip="单个文件不超过10MB"
          drag
          :onSuccessCallback="onSuccessCallback"
          :onDelSuccessCallback="onFileRemove"
        >
          <template #trigger>
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          </template>
        </upload-file>
      </el-form-item>
      <div class="grid grid-cols-2">
        <el-form-item label="文件URL" prop="fileUrl">
          <el-input v-model="form.fileUrl" readonly :disabled="true" />
        </el-form-item>
        <el-form-item label="文件名称" prop="fileName">
          <el-input v-model="form.fileName" readonly :disabled="true" />
        </el-form-item>
        <el-form-item label="扩展名" prop="fileExt">
          <el-input v-model="form.fileExt" readonly :disabled="true" />
        </el-form-item>
        <el-form-item label="文件大小(kb)" prop="fileSize">
          <el-input v-model="form.fileSize" type="number" readonly :disabled="true" />
        </el-form-item>
        <template v-if="formConfig.businessAttr1Show">
          <el-form-item :label="formConfig.businessAttr1Label" prop="businessAttr1">
            <el-input v-model="form.businessAttr1" />
          </el-form-item>
        </template>
        <template v-if="formConfig.businessAttr2Show">
          <el-form-item :label="formConfig.businessAttr2Label" prop="businessAttr2">
            <el-input v-model="form.businessAttr2" />
          </el-form-item>
        </template>
      </div>
      <el-form-item label="文件描述" prop="fileDesc">
        <el-input v-model="form.fileDesc" type="textarea" placeholder="请输入" clearable />
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="show = false">{{ $t('general.form.cancel') }}</el-button>
      <el-button :loading="formLoading" class="eu-submit-btn" type="primary" @click="onSubmit">{{ $t('general.form.submit') }}</el-button>
    </div>
  </el-dialog>
</template>
